var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"container"},[_c('div',{staticClass:"landing-footer"},[_c('p',{attrs:{"id":"copyright"}},[_vm._v(" ® Cámara de Comercio Servicios y Turísmo de Guadalajara. ")])])])
}]

export { render, staticRenderFns }